import { IonItem, IonIcon } from "@ionic/react";
import { chevronForwardOutline as rightArrowIcon } from "ionicons/icons";
import React from "react";
import { useHistory } from "react-router-dom";

import CategoryLabel from "../../atoms/CategoryLabel";
import { ICategory, IStudentGearBox } from "../../state";
import {
  boxesListPath,
  categorizedRealizationPath,
  realizationListPath,
  pulseSurveyPath,
} from "../../store/student";
import BoxLabel from "../../atoms/BoxLabel";
import pulseSurveyLogo from "../../assets/images/PulseSurvey/logo.svg";

import styles from "./RealizationList.module.scss";
export interface RealizationListProps {
  categories: ICategory[];
  gearBoxes: IStudentGearBox[];
}

const RealizationList = (props: RealizationListProps) => {
  const history = useHistory();
  const totalrealizationCount =
    props.categories.find(category => category.id === null)
      ?.realization_count ?? 0;
  const categories = props.categories.filter(c => {
    return c.id;
  });

  return (
    <div className={styles.wrapper}>
      {props.gearBoxes && props.gearBoxes.length > 0 && (
        <div className={styles.box}>
          <BoxLabel
            label="BOX"
            onClick={() => {
              history.push(`${realizationListPath}${boxesListPath}`);
            }}
          />
        </div>
      )}
      <div
        className={styles.item}
        onClick={() => {
          history.push(`${realizationListPath}${pulseSurveyPath}`);
        }}
      >
        <IonIcon
          slot="end"
          color="light"
          icon={pulseSurveyLogo}
          className={styles.icon}
        />
        <p className={styles.title}>デイリーストック</p>
        <IonIcon
          color="light"
          icon={rightArrowIcon}
          slot="end"
          className={styles.arrowIcon}
        />
      </div>
      <IonItem
        className={styles.all}
        detail
        onClick={() => history.push(`${categorizedRealizationPath}/0`)}
      >
        <div className={styles.categoryLabel}>
          <CategoryLabel
            selectable
            label="すべて"
            color="blue"
            count={totalrealizationCount}
          />
        </div>
      </IonItem>
      {categories &&
        categories.map(category => (
          <IonItem
            key={category.id}
            className={styles.categories}
            detail
            onClick={() => {
              history.push(`${categorizedRealizationPath}/${category.id}`);
            }}
          >
            <div className={styles.categoryLabel}>
              <CategoryLabel
                selectable
                label={category.name}
                color={category.color}
                count={category.realization_count}
                isTeacherCategory={!!category.teacher_id}
              />
            </div>
          </IonItem>
        ))}
    </div>
  );
};

export default RealizationList;
